import { render } from "./CopyString.vue?vue&type=template&id=6eaeefa2&scoped=true"
import script from "./CopyString.vue?vue&type=script&lang=js"
export * from "./CopyString.vue?vue&type=script&lang=js"

import "./CopyString.vue?vue&type=style&index=0&id=6eaeefa2&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eaeefa2"]])

export default __exports__